import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';
import te from './locales/te.json';

const STORAGE_KEY = 'lang';
const SUPPORTED = ['en', 'hi', 'te'];
const saved = localStorage.getItem(STORAGE_KEY);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    te: { translation: te },
  },
  lng: SUPPORTED.includes(saved) ? saved : 'en', // English is the default
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export const changeLanguage = (lang) => {
  if (!SUPPORTED.includes(lang)) return;
  i18n.changeLanguage(lang);
  localStorage.setItem(STORAGE_KEY, lang);
};

export default i18n;
